var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 18,
    height: 16,
    rx: 2,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H18V17C18 17.5523 17.5523 18 17 18H3C2.44772 18 2 17.5523 2 17V8Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 2,
    height: 2,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14,
    width: 2,
    height: 2,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 2,
    height: 2,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14,
    width: 2,
    height: 2,
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10,
    width: 2,
    height: 2,
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 14,
    width: 2,
    height: 2,
    fill: "currentColor"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 2,
    height: 5,
    rx: 1,
    fill: "currentColor"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 1,
    width: 2,
    height: 5,
    rx: 1,
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.3aea2ca556ad9de80f9c1061a98d7e20.svg";
export { ForwardRef as ReactComponent };